import React from "react";
import { Button, Statistic, Col } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import utils from "../../utils";
import { CONSTANTS } from "../../utils/constant";
import AppointmentJoinModal from "./AppointmentJoinModal";
import Icons from "Common/Icons";
import { withTranslation , Trans} from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import { connect } from "react-redux";
import ModalPopupComponent from "Components/ModalPopupComponent";
import DoctorPatientAvatar from "Components/DoctorPatientAvatar";
dayjs.extend(utc);
const { Countdown } = Statistic;
class MyAppointmentPatientCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        ...this.props.data,
        doctor_name : this.props.data.clinician_first_name,
        doctor_last_name : this.props.data.clinician_last_name,
      } || {},
      appointment_status: "missed",
      joinNow:
        dayjs(dayjs.utc().add(this.props.user_details.time_zone_offset_in_min, 'minute').format('YYYY-MM-DD HH:mm:ss')).add(1, "day") >= dayjs(this.props.data.appointment_date_time)
          ? true
          : false,
      show_buttons: this.props.show_buttons,
      showJoinorCounter:
        dayjs(dayjs.utc().add(this.props.user_details.time_zone_offset_in_min, 'minute').format('YYYY-MM-DD HH:mm:ss')).add(1, "day") >= dayjs(this.props.data.appointment_date_time)
          ? true
          : false,
      showJoinModal: false,
      dayjsToUTC: dayjs(
        dayjs
          .utc()
          .add(this.props.user_details.time_zone_offset_in_min, "minute")
          .format("YYYY-MM-DD HH:mm:ss")
      ),
      showJoinNowNew:false,
      showAll:true,
      closeModalReachesTime: false,
    };
    this.openCancelModal = this.openCancelModal.bind(this);
    this.openRescheduleModal = this.openRescheduleModal.bind(this);
    this.handleFunction = this.handleFunction.bind(this);
  }
  componentDidMount() {
    this.checkTimeDifference();
    this.interval = setInterval(this.checkTimeDifference, 1000); 
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  checkTimeDifference = () => {
    const { appointment_epoch } = this.state.data;
    let initialTime = dayjs.utc();
    let currentEpoch = Math.floor(initialTime / 1000);
    const timeDifference = appointment_epoch - currentEpoch;
    if (timeDifference < 0) {
      this.setState({ showJoinNowNew: true });
      if(!this.state.closeModalReachesTime){
        utils.Modal(false);
        this.setState({ closeModalReachesTime: true });
      }
      if(timeDifference < -11100){
        this.setState({ showAll: false, showJoinModal: false });
        clearInterval(this.interval);
      }
    } else {
      this.setState({ currentEpoch });
    }
  };
  isCurrentDate(val) {
    let c_date = this.state.dayjsToUTC.date(),
      c_month = this.state.dayjsToUTC.month(),
      c_year = this.state.dayjsToUTC.year();
    let s_date = dayjs(val).date(),
      s_month = dayjs(val).month(),
      s_year = dayjs(val).year();
    if (c_date == s_date && c_month == s_month && c_year == s_year) {
      return true;
    }
    return false;
  }
  handleFunction = (action) => {
    utils.Modal(false);
    if (action == "reschedule") {
      typeof this.props.handleFunction == "function" &&
        this.props.handleFunction("reschedule", this.state.data.appointment_id);      
    } else if (action == "cancel") {
      typeof this.props.handleFunction == "function" &&
        this.props.handleFunction("cancel", this.state.data.appointment_id);
    }
  };
  openRescheduleModal() {
    let { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang
    ? tgtLang + LANG_STYLD_EXT
    : tgtLang;
    utils.Modal(true, {
      content: (
        <ModalPopupComponent title={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.RESCHEDULE_APPOINTMENT,{lng:tgtLangST})}</Trans>} content={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.RESCHEDULE_MAIN_CONTENT,{lng:tgtLangST})}</Trans>}
         secondContent={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.RESCHEDULE_SECOND_CONTENT,{lng:tgtLangST})}</Trans>} button1={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.YES,{lng:tgtLangST})}</Trans>} className1={"common-button-green"} button2={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.NO,{lng:tgtLangST})}</Trans>} className2={"link-button-green"} onclick1={() => this.handleFunction("reschedule")} onclick2={() => utils.Modal(false)} />
      ),  width: "480px" });
  }
  openCancelModal() {
    let { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang
    ? tgtLang + LANG_STYLD_EXT
    : tgtLang;
    utils.Modal(true, {
      content: (
        <ModalPopupComponent title={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CANCEL_APPOINTMENT,{lng:tgtLangST})}</Trans>} 
        content={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CANCEL_MAIN_CONTENT,{lng:tgtLangST})}</Trans>} secondContent={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CANCEL_SECOND_CONTENT,{lng:tgtLangST})}</Trans>} button1={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.YES,{lng:tgtLangST})}</Trans>} className1={"common-button-red"} button2={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.NO,{lng:tgtLangST})}</Trans>} className2={"link-button-black"} onclick1={() => this.handleFunction("cancel")} onclick2={() => utils.Modal(false)} />

      ), width: "480px" });
  }

  setShowJoinModal(value) {
    this.setState({ showJoinModal: value });
  }

  render() {
    let { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang
    ? tgtLang + LANG_STYLD_EXT
    : tgtLang;
    return (
      <div className="my-appointment-card-container" >
        <div className="my-appointment-patient-main-wrapper border-removed">

          <div className="my-appointment-patient-main" style={{ borderRadius: this.state.data.appointment_status == "missed" || this.state.data.appointment_status == "cancelled" || this.state.data.appointment_status == "reschedule_requested" ? "14px 14px 0px 0px" : "" }}>
            <div className="">
              <div className="upcoming-app-img-container" type="primary">
                {/* <img src={this.state?.data?.profile_picture || Icons.icon_doctor_avatar}/> */}
                <DoctorPatientAvatar doc_img={this.state?.data?.profile_picture}  patient_img={this.props.user_details?.profile_picture}/>
              </div>

            </div>
            <div className="md-bottom-container">
              <div className="mid-content">
                <div className="app-detail-status-div">
                  {this.state.data?.clinician_first_name ? (
                    <div className="status-doctor-name">
                      {utils.FirstNameLastName(utils.salutationPrefixName(this.state.data?.salutation, utils.FormatName(
                        utils.getDisplayName(this.state.data.clinician_first_name, this.state.data.clinician_last_name))), "250px")}
                    </div>
                  ) :
                    <div className="status-doctor-name">
                      <Trans components={TS_STYLD_COMPS}>
                        {t(utils.clinicianToBeAssigned(this.state?.data?.appointment_status), { lng: tgtLangST })}
                      </Trans>
                    </div>
                  }
                  <div className="status-content-duration">
                    <div className="appointment-detailcall-type">
                      {this.state.data.specialization}
                    </div>
                  </div>
                  <div className="app-detail-time-div">
                    <div className="app-detail-time-container">
                      <div className="pending-time-content">
                        <div>
                          {utils.FormatDate(
                            this.state.data.appointment_date_time,
                            "DATE_TIME_1"
                          )}
                          {/* {this.state.data.appointment_status || "-"} */}
                        </div>
                      </div>
                      <div className={this.state.data.appointment_status == "accepted" ? "confirm-state" : this.state.data.appointment_status_label == "Cancelled" ? "cancelled-state" : "pending-state"}>
                       <img className="status-icons-appointmnets"  src=
                       {this.state.data.appointment_status == "accepted" ?Icons.calender_icon_2:this.state.data.appointment_status_label == "Cancelled" ? Icons.cancel_icon :Icons.pending_appointment}/> {this.state.data?.appointment_status_label}
                      </div>
                    </div>

                  </div>
                </div>

              </div>  


            </div>
          </div>




          <div className="patient-upcoming-app-bottom-container">
          <div className="action-btns" >
                {this.state.data.can_cancel &&
                  this.state.data.can_reschedule && !this.state.showJoinNowNew && this.state.showAll &&
                  this.state.dayjsToUTC <=
                  dayjs(this.state.data.appointment_date_time).add(
                    180,
                    "minutes"
                  ) &&
                  this.props.show_buttons ? (
                  <div className="app-detail-action-btn-container">
                      <>
                        {this.state.dayjsToUTC <=
                          dayjs(this.state.data.appointment_date_time).subtract(
                            300,
                            "seconds"
                          ) && <div className="app-detail-action-btn-content">
                            
                            <Button
                              onClick={this.openCancelModal}
                              className="cancel-btn-web" >
                             <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CANCEL,{lng:tgtLangST})}</Trans>
                            </Button>
                            <Button
                              onClick={this.openRescheduleModal}
                              className="reschedule-btn-web"
                            >
                             <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.RESCHEDULE,{lng:tgtLangST})}</Trans>
                            </Button>
                          </div>}

                      </>
                  </div>
                ) : null}
              </div>
              <div className="join-now-btn-container">
              {this.state.dayjsToUTC <=
                dayjs(this.state.data.appointment_date_time).add(
                  180,
                  "minutes"
                ) ? (
                <div className="appointment-actions">
                  {this.state?.data?.appointment_status=="accepted" &&
                    this.state.showJoinorCounter &&
                    this.props.show_buttons ? (
                    this.state.joinNow && this.state.showJoinNowNew && this.state.showAll ? (
                      <div className="action-content">
                        <Button className="join-now-btn"
                          // style={{marginTop: "28px"}}
                          onClick={() => {
                            this.setShowJoinModal(true);
                            // typeof this.props.handleFunction == "function" &&
                            // this.props.handleFunction("joinNow", this.state.data)
                          }}
                        >
                         <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.JOIN_NOW,{lng:tgtLangST})}</Trans> 
                          <span className="join-now">
                            <img className="join-now-icon" src={Icons.join_btn_icon} />
                          </span>
                        </Button>
                        {/* <div className="status-content">
                              <div>{this.state.data.appointment_status || "-"}</div>  
                          </div> */}
                      </div>


                    ) : (
                      <div className="countdown-container">
                        <Countdown
                          className="time-format"
                          title="Time to join call"
                          value={
                            new Date(this.state.data.appointment_date_time) -
                            1000 * 60 * 5
                          }
                          onFinish={() => {
                            this.setState({ joinNow: true });
                          }}
                        />
                      </div>
                    )
                  ) : null}

                  {this.state.showJoinModal && (
                    <AppointmentJoinModal
                      doctor_last_name={this.state.data.clinician_last_name}
                      setShowJoinModal={this.setShowJoinModal.bind(this)}
                      apptDetail={this.state.data}
                      role={this.props.role}
                    />
                  )}
                </div>
              ) : null}
            </div>
            <div className="appointment-status-container">
            
              <div className="appointment-status">{this.state.data.appointment_message || "-"} {this.state.data.appointment_message.includes("has been confirmed") && <img className="green-tick-icon" src={Icons.confirm_app_tick_icon}/>}</div>
            </div>
           
          </div>

        </div>

        {/* {this.state.data?.status =="missed" || this.state.data?.status=="cancelled" || this.state.data.status=="reschedule_requested" ? <div  className={`apt-status ${this.state.data.status}`  }> <p className="p-app-status">{CONSTANTS.APPOINTMENT_STATUS}: {utils.ConvertToPascalCase(this.state.data.status_label)}</p></div>:null} */}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
    includePrimeLang: state.loginReducer.includePrimeLang,
  };
};
export default connect(mapStateToProps)(
  withTranslation()(MyAppointmentPatientCard)
);
